import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPost, operationsClient } from '@/lib/api/client';
import { qboReconciliationEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';

export interface ResyncEntityVars {
  entity: string;
  id: string;
}

export interface ResyncEntityResult {
  success: boolean;
  jobName: string;
  jobId: string;
}

/**
 * Spec §9.7 — Manual replay of a dead-letter row. Resets the
 * SyncRecord and re-enqueues the entity-specific sync job. Used
 * primarily by the Dead-Letter queue's "Retry now" button.
 */
export function useResyncEntity() {
  const queryClient = useQueryClient();
  return useApiMutation<ResyncEntityResult, ResyncEntityVars>({
    mutationFn: ({ entity, id }) =>
      apiPost<ResyncEntityResult, undefined>(
        operationsClient,
        qboReconciliationEndpoints.resyncEntity(entity, id),
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: settingsKeys.qboDeadLetter(),
      });
      void queryClient.invalidateQueries({
        queryKey: settingsKeys.qboReconciliationLatest(),
      });
      toast.success('Sync queued');
    },
  });
}
